import { Box, Grid, Paper, Typography } from '@mui/material';
import { DashboardKpiResponse, DashboardStatistics as DashboardStatisticsType } from '../../types';
import { DashboardKpi } from './dashboard-kpi';

interface DashboardStatisticsProps {
  statistics: DashboardStatisticsType;
  pastDueCount: number;
  manufacturerId?: number;
  viewMode?: 'week' | 'month';
  year?: number;
  month?: number;
  kpiMetrics?: DashboardKpiResponse;
  onRefresh?: () => void;
}

export const DashboardStatistics = ({
  statistics,
  pastDueCount,
  manufacturerId: _manufacturerId,
  viewMode = 'month',
  year: _year,
  month: _month,
  kpiMetrics,
  onRefresh,
}: DashboardStatisticsProps) => {
  return (
    <>
      {/* KPI Section - Replaces the two graphs */}
      {kpiMetrics ? (
        <DashboardKpi kpiMetrics={kpiMetrics} viewMode={viewMode} onRefresh={onRefresh} />
      ) : null}

      <Grid container spacing={2} sx={{ mb: 2 }}>
        {/* Past Due Counter */}
        <Grid item xs={12} sm={3}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              textAlign: 'center',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h6" color="error">
              Orders Past Due
            </Typography>
            <Typography variant="h3" color="error">
              {pastDueCount}
            </Typography>
          </Paper>
        </Grid>

        {/* Monthly/Weekly Summary */}
        <Grid item xs={12} sm={9}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              {viewMode === 'week' ? 'Weekly Summary' : 'Monthly Summary'}
            </Typography>
            <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
              <Box sx={{ minWidth: 150 }}>
                <Typography variant="body2" color="text.secondary">
                  Total Feet
                </Typography>
                <Typography variant="h5" sx={{ wordBreak: 'break-word' }}>
                  {(statistics.totalInchesForMonth / 12).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
              <Box sx={{ minWidth: 150 }}>
                <Typography variant="body2" color="text.secondary">
                  Total Value
                </Typography>
                <Typography variant="h5" sx={{ wordBreak: 'break-word' }}>
                  ${statistics.totalValueForMonth.toLocaleString()}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};
